import React from "react";
import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { BASE_URL } from "../../config";
import { timeAgo , languageTranslation } from "../../helper";
import { useAlert } from 'react-alert';
import { Link, useHistory } from 'react-router-dom';
import { url } from '../../config';
import Loader from "../layout/Loader";
import maingLogo from '../../assets/images/logo-white.svg';
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../actions/userActions";
import { FormattedMessage } from 'react-intl';
import DivicesList from '../../assets/images/deivicslist.png'
import { NEW_FREE_PLAN_FEATURE, UNLIMITED_SEARCH, NEW_FREE_DOWNGRADE_FEATURE } from '../../constants/index';





const DeviceList = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  const [profileData, setProfileData] = useState({});

  const location = useLocation();
  const alert = useAlert();
  const history = useHistory();
  const { isAuthenticated, error, user, loading } = useSelector(state => state.user)
  const Auth_Tooken_old = location?.search?.split('?')[1] ? location?.search?.split('?')[1] : location?.state;
  const Auth_Tooken = Auth_Tooken_old?.split('%7C')?.length > 1 ? `${Auth_Tooken_old?.split('%7C')[0]}|${Auth_Tooken_old?.split('%7C')[1]?.split('&lang=')[0]}` : `${Auth_Tooken_old?.split('&lang=')[0]}`;

  useEffect(() => {
    if (Auth_Tooken_old?.split('&lang=')[1] && localStorage.getItem("lang") != Auth_Tooken_old?.split('&lang=')[1]) {
      localStorage.setItem("lang", Auth_Tooken_old?.split('&lang=')[1]);
      window.location.reload();
    }
    axios.get(`${BASE_URL}/get-user-device-list`, {
      headers: {
        Authorization: `Bearer ${Auth_Tooken}`,
      'lang': localStorage.getItem('lang'),
      }
    }).then((res) => {
      if (res?.data?.status) {
        if (res?.data?.data?.device_list?.length == 0) {
          // window.location.href = '/login'
    history.push({ pathname: url + "/login" });

        }
        setData(res?.data?.data?.device_list)
        setProfileData(res?.data?.data?.profile)
      }
    }).catch((err) => {
      alert.error("Something went wrong, please try again later")
    })
  }, [])

  const handelLogout = (data) => {
    const getUerDta = localStorage.getItem('user_data');
    const { email, password, address } = JSON.parse(getUerDta) || {};

    setShow(true)
    const payoad = {
      device_token: data?.device_token,
    }
    try {
      axios.post(`${BASE_URL}/delete-user-device`, payoad, {
        headers: {
          Authorization: `Bearer ${Auth_Tooken}`,
        }
      }).then((res) => {
        if (res?.data?.status) {
          setShow(false)
          if (location?.pathname == "/device-list/app") {
            alert.success("You can log in now on the mobile app.")
            return history.push({ pathname: url + "/login" });
          } else {
            return dispatch(login(email, password, address))
          }
        }
      }).catch((err) => {
        setShow(false)
        alert.error("Something went wrong, please try again later")
      })
    } catch (error) {
      setShow(false)
      alert.error("Something went wrong, please try again later")
    }
  }

  const handelNavigate = () => {
    // history.push(url + "/new-business-info");
    history.push({ pathname: url + "/new-business-info", state: { token: Auth_Tooken, userData: profileData } });

  }

  useEffect(() => {
    if (isAuthenticated) {
      if (user?.is_business_step === 0) {
        history.push(url + "/business-info");
        return;
      }
      if (user?.country_id === 225) {
        localStorage.setItem("country", 'turkey')
      } else {
        localStorage.setItem("country", 'uk')
      }
      history.push(url + "/category/diamonds")
    }

  }, [isAuthenticated, history, alert, user])

  // console.log(profileData?.next_plan_data , "=================>>>>>>>>DATA")
  return (
    <>
      {show || loading ? <Loader /> : null}
      <style>{`
        body {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
          background-color: #0b0e11ff !important;
          color: #FFFFFF;
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
        }

        .device-limit-container {
          width: 100%;
          max-width: 1400px;
          margin: 0 auto;
        }

        .device-limit-wrapper {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 60px;
          align-items: center;
          padding: 30px 40px;
        }

        .left-section {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 40px;
        }

        .device-illustration {
          width: 100%;
          max-width: 500px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .device-illustration img {
          width: 100%;
          height: auto;
          max-width: 500px;
        }

        .left-content {
          max-width: 500px;
        }

        .main-heading {
          font-size: 32px;
          font-weight: 600;
          line-height: 1.3;
          color: #fff;
          margin-bottom: 12px;
          letter-spacing: -0.5px;
        }

        .sub-heading {
          font-size: 18px;
          font-weight: 400;
          color: #fff;
          line-height: 1.5;
        }

        .right-section {
          display: flex;
          flex-direction: column;
          gap: 32px;
          max-width: 500px;
        }

        .action-heading {
          font-size: 24px;
          font-weight: 600;
          color: #fff;
          margin-bottom: 8px;
          letter-spacing: -0.3px;
        }

        .current-device-section {
          background-color: #0b0e11ff !important;
          border-radius: 12px;
          padding: 20px 24px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 20px;
        }

        .device-info {
          display: flex;
          align-items: center;
          gap: 16px;
          flex: 1;
        }

        .device-icon-phone {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .device-details {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .device-name {
          font-size: 16px;
          font-weight: 500;
          color: #f8fafcff;
          line-height: 1.4;
        }

        .device-last-used {
          font-size: 14px;
          font-weight: 400;
          color: #717171;
          line-height: 1.4;
        }

        .logout-btn {
          background-color:#544343;
          color: #FFFFFF;
          border: none;
          border-radius: 8px;
          padding: 12px 24px;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          white-space: nowrap;
          font-family: inherit;
        }

        .logout-btn:hover {
          background-color: #E02424;
          transform: translateY(-1px);
        }

        .logout-btn:active {
          transform: translateY(0);
        }

        .divider-section {
          display: flex;
          align-items: center;
          gap: 16px;
          margin: 8px 0;
        }

        .divider-line {
          flex: 1;
          height: 1px;
          background-color: #f2f2f2;
        }

        .divider-text {
          font-size: 14px;
          font-weight: 500;
          color: #f2f2f2;
          white-space: nowrap;
        }

        .upgrade-section {
          background-color: #fff;
          border-radius: 12px;
          padding: 24px;
          cursor: pointer;
          transition: all 0.2s ease;
          position: relative;
        }

        .upgrade-section:hover {
          border-color: #3B454A;
          transform: translateY(-2px);
        }

        .upgrade-section.recommended {
          background-color: #302929ff;
        }

        .recommended-badge {
          color: transparent;
          font-size: 15px;
          font-weight: 600;
          letter-spacing: 0.5px;
          text-transform: uppercase;
          width: fit-content;
          margin-bottom: 12px;
          background: linear-gradient(90deg, #eaba1d, #ffe3a0, #eaba1d);
          -webkit-background-clip: text;
        }

        .upgrade-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 20px;
        }

        .upgrade-info {
          display: flex;
          flex-direction: column;
          gap: 6px;
          flex: 1;
        }

        .upgrade-title {
          font-size: 18px;
          font-weight: 600;
          color: #fcfcfcff;
          line-height: 1.3;
        }

        .upgrade-features {
          font-size: 14px;
          font-weight: 400;
          color: #faebebff;
          line-height: 1.4;
        }

        .upgrade-arrow {
          color: #f2f3f5ff;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          transition: transform 0.2s ease;
        }

        .upgrade-section:hover .upgrade-arrow {
          transform: translateX(4px);
        }

          .top-logo{
            margin: 0 auto;
            display: block;
            margin-bottom: 20px;
            width: 240px;
          }
        @media (max-width: 1024px) {
          .device-limit-wrapper {
            grid-template-columns: 1fr;
            gap: 40px;
          }

          .left-section {
            order: 1;
          }

          .right-section {
            order: 2;
            max-width: 100%;
          }
        }

        @media (max-width: 768px) {
          .device-limit-wrapper {
            padding: 20px;
            gap: 32px;
          }

          .main-heading {
            font-size: 26px;
          }

          .sub-heading {
            font-size: 16px;
          }

          .action-heading {
            font-size: 20px;
          }

          .current-device-section {
            flex-direction: column;
            align-items: flex-start;
          }

          .logout-btn {
            width: 100%;
          }

          .device-illustration svg {
            max-width: 100%;
          }
        }

        @media (max-width: 480px) {
          .device-limit-wrapper {
            padding: 30px 16px;
          }

          .main-heading {
            font-size: 22px;
          }

          .device-illustration svg {
            max-width: 100%;
          }
        }
      `}</style>

      <div className="device-limit-container">
        <img
          src={maingLogo}

          class="top-logo"
          alt=""
        />

        <div className="device-limit-wrapper">
          {/* Left Section */}
          <div className="left-section">
            <div className="device-illustration">
              {/* SVG Illustration */}
              <img src={DivicesList} alt="deivicslist"></img>
            </div>
            <div className="left-content">
              <h1 className="main-heading">
                <FormattedMessage id="DiviceFirst" defaultMessage="DiviceFirst" />
              </h1>
              {/* <p className="sub-heading">
              </p> */}
              <p className="sub-heading">
                {/* {profileData?.current_plan_data?.name} <br/>

                {profileData?.current_plan_data?.name}, {profileData?.current_plan_data?.device_limit}
                        {" "}
                      {languageTranslation(profileData?.next_plan_data?.device_limit)}, {' '}    <span>{profileData?.current_plan_data?.feature_content}</span>
                     */}
                <FormattedMessage id="DiviceSecond" defaultMessage="DiviceSecond" />{profileData?.device_limit || '0'} <FormattedMessage id="Deviceonly" defaultMessage="Deviceonly" />
              </p>
            </div>
          </div>

          {/* Right Section */}
          <div className="right-section">
            <h2 className="action-heading">
              <FormattedMessage id="DiviceThree" defaultMessage="DiviceThree" />
            </h2>

            {data?.map((res, i) => (

              <div className="current-device-section" key={i}>
                <div className="device-info">
                  <div className="device-icon-phone">
                    {res?.device_type == "WEB" ?
                      <svg
                        width="24"
                        height="40"
                        viewBox="0 0 24 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="2"
                          y="8"
                          width="20"
                          height="14"
                          rx="2"
                          fill="#deebf1ff"
                          stroke="#edf0f7ff"
                          stroke-width="1.5"
                        />
                        <rect
                          x="4"
                          y="10"
                          width="16"
                          height="10"
                          rx="1"
                          fill="#1A1F26"
                        />
                        <rect
                          x="9"
                          y="24"
                          width="6"
                          height="3"
                          rx="1"
                          fill="#edf2f5ff"
                          stroke="#ebedf1ff"
                          stroke-width="1.2"
                        />
                        <rect
                          x="6"
                          y="28"
                          width="12"
                          height="2"
                          rx="1"
                          fill="#e0e3ebff"
                        />
                      </svg>

                      :
                      <svg
                        width="24"
                        height="40"
                        viewBox="0 0 24 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="4"
                          y="2"
                          width="16"
                          height="36"
                          rx="3"
                          fill="#ebf2f7ff"
                          stroke="#0f1118ff"
                          strokeWidth="1.5"
                        />
                        <rect x="6" y="6" width="12" height="28" rx="1" fill="#000000ff" />
                        <circle cx="12" cy="36" r="1.5" fill="#08090aff" />
                      </svg>
                    }
                  </div>
                  <div className="device-details">
                    <div className="device-name">
  {res?.device_type === "WEB"
    ? `${res?.device_type}`
    : res?.model && res?.brand
      ? `${res?.brand} ${res?.model}`
      : res?.device_type}
</div>

                    {/* <div className="device-name">{res?.device_type == "WEB" ? res?.device_type : `${res?.model != null && res?.brand != null ? `${res?.model}` `${res?.brand}` : res?.device_type}`}  {res?.device_type == "WEB" ? res?.device_unique_id?.slice(0, 15) : null}</div> */}
                    {res?.updated_at ?
                      <div className="device-last-used">
                        <FormattedMessage id="LastUser" defaultMessage="LastUser" />
                        : {timeAgo(res?.updated_at)}</div>
                      : null}
                  </div>
                </div>
                <button className="logout-btn" onClick={() => handelLogout(res)}>
                  <FormattedMessage id="main.header.logout" defaultMessage="main.header.logout" />

                </button>
              </div>
            ))}

            <div className="divider-section">
              <div className="divider-line" style={{background:"linear-gradient(90deg, rgba(79, 79, 79, 0) 0%, rgb(79 79 79) 30%)"}}></div>
              <span className="divider-text">
                <FormattedMessage id="Upgrade Plan" defaultMessage="Upgrade Plan" />
              </span>
              <div className="divider-line" style={{background:"linear-gradient(90deg, rgb(79 79 79) 70%, rgba(79, 79, 79, 0) 100%)"}}></div>
            </div>

            {profileData?.is_upgrade_plan_show == '1'  ?
              <div className="upgrade-section recommended" onClick={handelNavigate}>
                <div className="recommended-badge">
                  <FormattedMessage id="RECOMMENDED" defaultMessage="RECOMMENDED" />
                </div>
                <div className="upgrade-content">
                  <div className="upgrade-info">
                    <div className="upgrade-title">
                      <FormattedMessage id="Upgrade Plan" defaultMessage="Upgrade Plan" />
                    </div>
                    <div className="upgrade-features">
                      <p>{profileData?.next_plan_data?.name}, {profileData?.next_plan_data?.device_limit}
                        {" "}
                      {languageTranslation(profileData?.next_plan_data?.device_limit)}, {' '}  
                      <span>{profileData?.next_plan_data?.feature_content}</span>
                      </p>
                    </div>
                  </div>
                  <div className="upgrade-arrow">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 18L15 12L9 6"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              : null}


               {profileData?.is_valid_plan == "1" && profileData?.is_grace_period == "1" ?
              <div className="upgrade-section recommended" onClick={handelNavigate}>
                <div className="recommended-badge">
                  <FormattedMessage id="renewPlan" defaultMessage="renewPlan" />
                </div>
                <div className="upgrade-content">
                  <div className="upgrade-info">
                    <div className="upgrade-title">
                      {/* <FormattedMessage id="renewPlan" defaultMessage="renewPlan" /> */}
                    </div>
                    <div className="upgrade-features">
                      <p>{profileData?.current_plan_data?.name}, {profileData?.current_plan_data?.device_limit}
                        {" "}
                      {languageTranslation(profileData?.current_plan_data?.device_limit)}, {' '}  
                      <span>{profileData?.current_plan_data?.feature_content}</span>

                      </p>
                    </div>
                  </div>
                  <div className="upgrade-arrow">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 18L15 12L9 6"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              : null}


          </div>
        </div>
      </div>
    </>
  );
};



export default DeviceList